import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
export var NoSchedulesTodayMessage = function NoSchedulesTodayMessage() {
  return React.createElement("div", {
    className: "schedule__message"
  }, React.createElement(FormattedMessage, {
    id: "schedule.no-results",
    defaultMessage: "There are no upcoming classes on this day"
  }));
};
export var NoSchedulesSelectedDateMessage = function NoSchedulesSelectedDateMessage(_ref) {
  var date = _ref.date;
  return React.createElement("div", {
    className: "schedule__header-message"
  }, React.createElement(FormattedMessage, {
    id: "schedule.noClasses",
    defaultMessage: "There are no classes {date}.",
    values: {
      date: date
    }
  }));
};
NoSchedulesSelectedDateMessage.propTypes = {
  date: PropTypes.node.isRequired
};
export var NoSchedulesOfClassTodayMessage = function NoSchedulesOfClassTodayMessage(_ref2) {
  var nameOfClass = _ref2.nameOfClass,
      venueUrl = _ref2.venueUrl;
  return React.createElement("div", {
    className: "schedule__message"
  }, React.createElement(FormattedMessage, {
    id: "schedule.no-results-for-class",
    defaultMessage: "There are no upcoming \u201C{nameOfClass}\u201D classes on this day.",
    values: {
      nameOfClass: nameOfClass
    }
  }), React.createElement("p", {
    className: "mt"
  }, React.createElement(FormattedMessage, {
    id: "schedule.no-results-for-class.line-2",
    defaultMessage: "{link} to see other classes.",
    values: {
      link: React.createElement(Link, {
        to: venueUrl
      }, React.createElement(FormattedMessage, {
        id: "schedule.no-results-for-class.link",
        defaultMessage: "View the full studio schedule"
      }))
    }
  })));
};
NoSchedulesOfClassTodayMessage.propTypes = {
  nameOfClass: PropTypes.string.isRequired,
  venueUrl: PropTypes.string.isRequired
};
export var SchedulesErrorMessage = function SchedulesErrorMessage(_ref3) {
  var onClick = _ref3.onClick;
  return React.createElement("div", {
    className: "schedule__message"
  }, React.createElement(FormattedMessage, {
    id: "schedule.error-loading",
    defaultMessage: "There was an error loading the schedule."
  }), React.createElement("p", {
    className: "mt"
  }, React.createElement("button", {
    onClick: onClick,
    className: "bt bt--tertiary bt--width-md"
  }, React.createElement(FormattedMessage, {
    id: "schedule.error-loading.retry",
    defaultMessage: "Retry"
  }))));
};
SchedulesErrorMessage.propTypes = {
  onClick: PropTypes.func.isRequired
};
export var SchedulesLoadingMessage = function SchedulesLoadingMessage() {
  return React.createElement("div", {
    className: "schedule__message"
  }, React.createElement(FormattedMessage, {
    id: "schedule.loading",
    defaultMessage: "Loading schedule"
  }));
};
export var SchedulesAlert = function SchedulesAlert(_ref4) {
  var children = _ref4.children;
  return React.createElement("div", {
    className: "schedule__alert-message"
  }, children);
};
SchedulesAlert.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired
};
export var NextCycleMessage = function NextCycleMessage() {
  return React.createElement(SchedulesAlert, null, React.createElement(FormattedMessage, {
    id: "schedule.nextCycle",
    defaultMessage: "You are viewing classes in your next cycle"
  }));
};